import React from "react";

const HisabBook = () => {
  return (
    <div className="page-content">
      <div className="container-fluid">
        <h2>HisabBook</h2>
        <p>Content for HisabBook page will go here.</p>
      </div>
    </div>
  );
};

export default HisabBook;
